// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");

function reportId(t) {
  return t.reportId;
}

function name(t) {
  return t.name;
}

function path(t) {
  return t.path;
}

function decode(json) {
  return {
          reportId: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json),
          path: Json_decode.field("path", Json_decode.string, json)
        };
}

var Report = {
  reportId: reportId,
  name: name,
  path: path,
  decode: decode
};

function CampaignReportList(props) {
  var id = props.id;
  var match = React.useState(function (param) {
        return /* [] */0;
      });
  var setReports = match[1];
  var match$1 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  React.useEffect((function (param) {
          Js_promise.then_((function (reports) {
                  return Promise.resolve((console.log(reports), Curry._1(setReports, (function (param) {
                                      return reports;
                                    }))));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/campaign_reports?campaign_id=" + id, (function (param) {
                      return Json_decode.field("reports", (function (param) {
                                    return Json_decode.list(decode, param);
                                  }), param);
                    })));
        }), []);
  var handleOnClick = function ($$event, url) {
    $$event.preventDefault();
    RescriptReactRouter.push(url);
  };
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(Curry._1(match$1[0], "ShowReport") ? JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("h2", {
                                        children: "Reports",
                                        className: "text-xl font-semibold"
                                      }),
                                  className: "flex items-center p-20-px"
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("table", {
                                        children: [
                                          JsxRuntime.jsx("thead", {
                                                children: JsxRuntime.jsxs("tr", {
                                                      children: [
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "Id",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-2"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      "Name",
                                                                      JsxRuntime.jsx("img", {
                                                                            className: "ml-4-px",
                                                                            src: Image$ReactHooksTemplate.heading
                                                                          })
                                                                    ],
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-2"
                                                            }),
                                                        JsxRuntime.jsx("th", {
                                                              children: JsxRuntime.jsx("div", {
                                                                    children: "",
                                                                    className: "flex"
                                                                  }),
                                                              className: "px-4 py-2"
                                                            })
                                                      ]
                                                    }),
                                                className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                              }),
                                          JsxRuntime.jsx("tbody", {
                                                children: $$Array.of_list(List.map((function (report) {
                                                            var reportPath = report.path;
                                                            var url = reportPath;
                                                            return JsxRuntime.jsxs("tr", {
                                                                        children: [
                                                                          JsxRuntime.jsx("td", {
                                                                                children: JsxRuntime.jsx("a", {
                                                                                      children: String(report.reportId),
                                                                                      onClick: (function ($$event) {
                                                                                          handleOnClick($$event, url);
                                                                                        })
                                                                                    }, id),
                                                                                className: "px-4 py-2"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: JsxRuntime.jsx("a", {
                                                                                      children: report.name,
                                                                                      onClick: (function ($$event) {
                                                                                          handleOnClick($$event, url);
                                                                                        })
                                                                                    }, id),
                                                                                className: "px-4 py-2"
                                                                              }),
                                                                          JsxRuntime.jsx("td", {
                                                                                children: JsxRuntime.jsx("a", {
                                                                                      children: JsxRuntime.jsx("button", {
                                                                                            children: "View Report",
                                                                                            className: "bg-pigmentblue hover:bg-cetaceanblue\n                          border border-gray-400\n                          flex justify-end rounded py-2 px-3 gap-1 text-sm text-white font-normal items-center",
                                                                                            id: "view_report"
                                                                                          }),
                                                                                      onClick: (function ($$event) {
                                                                                          handleOnClick($$event, url);
                                                                                        })
                                                                                    }, id),
                                                                                className: "px-4 py-2"
                                                                              })
                                                                        ],
                                                                        className: "border-b border-bottom-gray-600"
                                                                      }, id);
                                                          }), match[0]))
                                              })
                                        ],
                                        className: "text-left table-auto w-full border-separate text-xs font-medium"
                                      }),
                                  className: "flex px-20-px"
                                })
                          ]
                        }) : JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                                img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                                text: "401: Unauthorized!!",
                                loading: false
                              }),
                          className: "h-screen w-full animated fadeIn"
                        }))
            });
}

var emptyReports = /* [] */0;

var make = CampaignReportList;

exports.emptyReports = emptyReports;
exports.Report = Report;
exports.make = make;
/* react Not a pure module */
